module.exports = __webpack_public_path__ + "static/media/min-UNILAG-card.5f761aa2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/min-UNILAG-card.jpg
// module id = 392
// module chunks = 0